import { z } from 'zod';

/**
 * CR-55 — an exchange rate is NOT money. `zMoney` allows four places and would be the wrong
 * validator; a rate carries up to eight (NUMERIC(19,8)). It is a decimal STRING end to end and
 * never a JS number (NF-04). Zero is refused: a rate of zero would make every price free.
 */
export const RATE_PATTERN = /^\d{1,11}(\.\d{1,8})?$/;

export const zRate = z.string()
  .regex(RATE_PATTERN, 'A rate is a positive decimal with at most 8 decimal places')
  .refine((v) => /[1-9]/.test(v), 'A rate of zero would make every price free');

export const zFxRate = z.object({
  id: z.string().uuid(),
  baseCurrency: z.string().length(3),
  quoteCurrency: z.string().length(3),
  rate: z.string(),
  effectiveFrom: z.string(),
  source: z.string().nullable(),
  enteredByEmail: z.string().nullable(),
  createdAt: z.string(),
});

export const zCreateFxRate = z.object({
  quoteCurrency: z.string().length(3).regex(/^[A-Z]{3}$/, 'Use the 3-letter uppercase currency code'),
  rate: zRate,
  effectiveFrom: z.string().datetime({ offset: true }),
  source: z.string().trim().max(500).optional(),
});

export type FxRate = z.infer<typeof zFxRate>;
export type CreateFxRate = z.infer<typeof zCreateFxRate>;
